import { render, staticRenderFns } from "./LoginApp.vue?vue&type=template&id=4bbdcd22&"
import script from "./LoginApp.vue?vue&type=script&lang=js&"
export * from "./LoginApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports